// Roles that may sign in to this web app. An ALLOWLIST: every other role (user, superadmin, any role added later) is refused.
//
// The server opens a session for any valid account whatever its role (its login has no role check), so the rule is
// enforced here, in the frontend: store/authStore.js refuses a disallowed role at every sign-in path, discards a saved or
// refreshed session of such a role, and the route guards sign it out instead of redirecting it in a loop.
export const LOGIN_ROLES = Object.freeze(['OWNER', 'OPERATOR', 'admin']);

/** May an account with this role sign in to the web app? */
export const canSignIn = (role) => LOGIN_ROLES.includes(role);
